// extracted by mini-css-extract-plugin
module.exports = {"Container":"CoinDieTokenTopScreen_Container__3UF84","token-in-out":"CoinDieTokenTopScreen_token-in-out__3DEvC"};